import {dataConstants} from '../constants'

export const dataActions = {
    eventcategoryFetchRequest,
    eventcategoryFetchSuccess,
    eventcategoryFetchFailure,

    eventcategorySetRequest,
    eventcategorySetSuccess,
    eventcategorySetFailure,
    eventcategorySetClear,

    eventcategoryAddRequest,
    eventcategoryAddSuccess,
    eventcategoryAddFailure,

    eventcategoryUpdateRequest,
    eventcategoryUpdateSuccess,
    eventcategoryUpdateFailure,

    eventcategoryDeleteRequest,
    eventcategoryDeleteSuccess,
    eventcategoryDeleteFailure,

    eventoccurGetRequest,
    eventoccurGetSuccess,
    eventoccurGetFailure,
    eventoccurGetClear,

    eventoccurAddRequest,
    eventoccurAddSuccess,
    eventoccurAddFailure,

    eventoccurUpdateRequest,
    eventoccurUpdateSuccess,
    eventoccurUpdateFailure,

    eventoccurDeleteRequest,
    eventoccurDeleteSuccess,
    eventoccurDeleteFailure,

    eventOccurSwipersGetRequest,
    eventOccurSwipersGetSuccess,
    eventOccurSwipersGetFailure,
    eventOccurSwipersGetClear,

    eventOccurSwipersUpdateRequest,
    eventOccurSwipersUpdateSuccess,
    eventOccurSwipersUpdateFailure,

    eventFetchRequest,
    eventFetchSuccess,
    eventFetchFailure,

    occurSetRequest,
    occurSetSuccess,
    occurSetFailure,
    occurSetClear,

    lookupRequest,
    lookupSuccess,
    lookupFailure,
    lookupClearParams,
    lookupClearResults,

    lookupEUIDRequest,
    lookupEUIDSuccess,
    lookupEUIDFailure,
    lookupEUIDClearResults,

    swipeRequest,
    swipeSuccess,
    swipeFailure,

    getbatchswipeemplidsRequest,
    getbatchswipeemplidsSuccess,
    getbatchswipeemplidsFailure,

    batchswipevalidateRequest,
    batchswipevalidateSuccess,
    batchswipevalidateFailure,
    batchswipevalidateClear,

    batchswiperecordRequest,
    batchswiperecordSuccess,
    batchswiperecordFailure,

    swipeteamsFetchRequest,
    swipeteamsFetchSuccess,
    swipeteamsFetchFailure,

    getswipeteamFetchRequest,
    getswipeteamFetchSuccess,
    getswipeteamFetchFailure,
    getswipeteamClearResults,

    swipeteamAddRequest,
    swipeteamAddSuccess,
    swipeteamAddFailure,

    swipeteamUpdateRequest,
    swipeteamUpdateSuccess,
    swipeteamUpdateFailure,

    swipeteamDeleteRequest,
    swipeteamDeleteSuccess,
    swipeteamDeleteFailure,

    engagementtypeRequest,
    engagementtypeSuccess,
    engagementtypeFailure,

    departmentsDataRequest,
    departmentsDataSuccess,
    departmentsDataFailure,

    setdepartmentsDataRequest,
    setdepartmentsDataSuccess,
    setdepartmentsDataFailure,

    getsuperadminsRequest,
    getsuperadminsSuccess,
    getsuperadminsFailure,

    putsuperadminRequest,
    putsuperadminSuccess,
    putsuperadminFailure,

    manageroledeptSetRequest,
    manageroledeptSetSuccess,
    manageroledeptSetFailure,
    manageroledeptSetClear,

    manageroledeptAddRequest,
    manageroledeptAddSuccess,
    manageroledeptAddFailure,

    manageroledeptUpdateRequest,
    manageroledeptUpdateSuccess,
    manageroledeptUpdateFailure,

    manageroledeptDeleteRequest,
    manageroledeptDeleteSuccess,
    manageroledeptDeleteFailure,

    departmentusersGetRequest,
    departmentusersGetSuccess,
    departmentusersGetFailure,
    departmentusersGetClear,

    departmentusersAddRequest,
    departmentusersAddSuccess,
    departmentusersAddFailure,

    departmentusersUpdateRequest,
    departmentusersUpdateSuccess,
    departmentusersUpdateFailure,

    departmentusersDeleteRequest,
    departmentusersDeleteSuccess,
    departmentusersDeleteFailure,

    allusersGetRequest,
    allusersGetSuccess,
    allusersGetFailure,
    allusersGetClear,
}

/********* Event Category Actions  *********************************/
function eventcategoryFetchRequest(token, deptId) {
    return {type: dataConstants.DATA_EVENTCATEGORY_REQUEST, token, deptId}
}

// Note that this action takes its data from the DataFetchService function getDataAPI
// Hence it does not need to pass a parameter when it is called.
// Please review the datafetch.reducer.js file for details
function eventcategoryFetchSuccess(eventcategorylist) {
    return {type: dataConstants.DATA_EVENTCATEGORY_SUCCESS, eventcategorylist}
}

function eventcategoryFetchFailure(message) {
    return {type: dataConstants.DATA_EVENTCATEGORY_FAILURE, message}
}

/********* Event Setup Set Category Actions  *********************************/
function eventcategorySetRequest(payload) {
    return {
        type: dataConstants.DATA_SETEVTCATEGORY_REQUEST,
        payload,
    }
}

function eventcategorySetSuccess(eventcategory) {
    return {type: dataConstants.DATA_SETEVTCATEGORY_SUCCESS, eventcategory}
}

function eventcategorySetFailure() {
    return {type: dataConstants.DATA_SETEVTCATEGORY_FAILURE}
}

function eventcategorySetClear(eventcategory) {
    return {type: dataConstants.DATA_SETEVTCATEGORY_CLEAR, eventcategory}
}

/********* Event Setup ADD Category Actions  *********************************/
function eventcategoryAddRequest(token, payload) {
    return {
        type: dataConstants.DATA_ADDEVTCATEGORY_REQUEST,
        token,
        payload,
    }
}

function eventcategoryAddSuccess(data) {
    return {type: dataConstants.DATA_ADDEVTCATEGORY_SUCCESS, data}
}

function eventcategoryAddFailure(token) {
    return {type: dataConstants.DATA_ADDEVTCATEGORY_FAILURE, token}
}

/********* Event Setup UPDATE Category Actions  *********************************/
function eventcategoryUpdateRequest(token, payload) {
    return {
        type: dataConstants.DATA_UPDATEEVTCATEGORY_REQUEST,
        token,
        payload,
    }
}

function eventcategoryUpdateSuccess(data) {
    return {type: dataConstants.DATA_UPDATEEVTCATEGORY_SUCCESS, data}
}

function eventcategoryUpdateFailure(token) {
    return {type: dataConstants.DATA_UPDATEEVTCATEGORY_FAILURE, token}
}

/********* Event Setup DELETE Category Actions  *********************************/
function eventcategoryDeleteRequest(token, payload) {
    return {
        type: dataConstants.DATA_DELEVTCATEGORY_REQUEST,
        token,
        payload,
    }
}

function eventcategoryDeleteSuccess() {
    return {type: dataConstants.DATA_DELEVTCATEGORY_SUCCESS}
}

function eventcategoryDeleteFailure() {
    return {type: dataConstants.DATA_DELEVTCATEGORY_FAILURE}
}

/********* Event Setup Get Occurrences Actions  *********************************/
function eventoccurGetRequest(payload) {
    return {
        type: dataConstants.DATA_GETEVTOCCURRENCES_REQUEST,
        payload,
    }
}

function eventoccurGetSuccess(eventoccurrence) {
    return {type: dataConstants.DATA_GETEVTOCCURRENCES_SUCCESS, eventoccurrence}
}

function eventoccurGetFailure() {
    return {type: dataConstants.DATA_GETEVTOCCURRENCES_FAILURE}
}

function eventoccurGetClear(eventoccurrence) {
    return {type: dataConstants.DATA_GETEVTOCCURRENCES_CLEAR, eventoccurrence}
}

/********* Event Setup Create Occurrence Actions  *********************************/
function eventoccurAddRequest(token, payload) {
    return {
        type: dataConstants.DATA_ADDEVTOCCURRENCES_REQUEST,
        token,
        payload,
    }
}

function eventoccurAddSuccess(eventoccurrence) {
    return {type: dataConstants.DATA_ADDEVTOCCURRENCES_SUCCESS, eventoccurrence}
}

function eventoccurAddFailure() {
    return {type: dataConstants.DATA_ADDEVTOCCURRENCES_FAILURE}
}

/********* Event Setup Update Occurrence Actions  *********************************/
function eventoccurUpdateRequest(token, payload) {
    return {
        type: dataConstants.DATA_UPDEVTOCCURRENCES_REQUEST,
        token,
        payload,
    }
}

function eventoccurUpdateSuccess(eventoccurrence) {
    return {type: dataConstants.DATA_UPDEVTOCCURRENCES_SUCCESS, eventoccurrence}
}

function eventoccurUpdateFailure() {
    return {type: dataConstants.DATA_UPDEVTOCCURRENCES_FAILURE}
}

/********* Event Setup Delete Occurrence Actions  *********************************/
function eventoccurDeleteRequest(token, payload) {
    return {
        type: dataConstants.DATA_DELEVTOCCURRENCES_REQUEST,
        token,
        payload,
    }
}

function eventoccurDeleteSuccess() {
    return {type: dataConstants.DATA_DELEVTOCCURRENCES_SUCCESS}
}

function eventoccurDeleteFailure() {
    return {type: dataConstants.DATA_DELEVTOCCURRENCES_FAILURE}
}

/********* Event Setup Occurrence Swipers Actions  *********************************/
function eventOccurSwipersGetRequest(token, payload) {
    return {
        type: dataConstants.DATA_GETEVTOCCURSWIPERS_REQUEST,
        token,
        payload,
    }
}

function eventOccurSwipersGetSuccess(data) {
    return {type: dataConstants.DATA_GETEVTOCCURSWIPERS_SUCCESS, data}
}

function eventOccurSwipersGetFailure(token) {
    return {type: dataConstants.DATA_GETEVTOCCURSWIPERS_FAILURE, token}
}

function eventOccurSwipersGetClear() {
    return {type: dataConstants.DATA_GETEVTOCCURSWIPERS_CLEAR}
}

function eventOccurSwipersUpdateRequest(token, payload) {
    return {
        type: dataConstants.DATA_UPDEVTOCCURSWIPERS_REQUEST,
        token,
        payload,
    }
}

function eventOccurSwipersUpdateSuccess(data) {
    return {type: dataConstants.DATA_UPDEVTOCCURSWIPERS_SUCCESS, data}
}

function eventOccurSwipersUpdateFailure(token) {
    return {type: dataConstants.DATA_UPDEVTOCCURSWIPERS_FAILURE, token}
}

/********* Swiper Home Event Actions  *********************************/
function eventFetchRequest(token) {
    return {type: dataConstants.DATA_EVENT_REQUEST, token}
}

function eventFetchSuccess(eventlist) {
    return {type: dataConstants.DATA_EVENT_SUCCESS, eventlist}
}

function eventFetchFailure(message) {
    return {type: dataConstants.DATA_EVENT_FAILURE, message}
}

/********* Swiper Home Set Occurrence Actions  *********************************/
function occurSetRequest(payload) {
    return {
        type: dataConstants.DATA_OCCURRENCES_REQUEST,
        payload,
    }
}

function occurSetSuccess(occurrence) {
    return {type: dataConstants.DATA_OCCURRENCES_SUCCESS, occurrence}
}

function occurSetFailure() {
    return {type: dataConstants.DATA_OCCURRENCES_FAILURE}
}

function occurSetClear(occurrence) {
    return {type: dataConstants.DATA_OCCURRENCES_CLEAR, occurrence}
}

/********* Lookup Actions  *********************************/
function lookupRequest(token, values) {
    return {
        type: dataConstants.DATA_LOOKUP_REQUEST,
        token,
        values,
    }
}

function lookupSuccess(data) {
    return {type: dataConstants.DATA_LOOKUP_SUCCESS, data}
}

function lookupFailure(token) {
    return {type: dataConstants.DATA_LOOKUP_FAILURE, token}
}

function lookupClearParams() {
    return {type: dataConstants.DATA_LOOKUP_CLEARPARAMS}
}

function lookupClearResults() {
    return {type: dataConstants.DATA_LOOKUP_CLEARRESULTS}
}

/********* Lookup EUID Actions  *********************************/
function lookupEUIDRequest(token, euid) {
    return {
        type: dataConstants.DATA_LOOKUPEUID_REQUEST,
        token,
        euid,
    }
}

function lookupEUIDSuccess(data) {
    return {type: dataConstants.DATA_LOOKUPEUID_SUCCESS, data}
}

function lookupEUIDFailure(token) {
    return {type: dataConstants.DATA_LOOKUPEUID_FAILURE, token}
}

function lookupEUIDClearResults() {
    return {type: dataConstants.DATA_LOOKUPEUID_CLEARRESULTS}
}

/********* Recording Single Swipe Actions  *********************************/
function swipeRequest(token, eventId, occurId, emplId) {
    return {
        type: dataConstants.DATA_SWIPE_REQUEST,
        token,
        eventId,
        occurId,
        emplId,
    }
}

function swipeSuccess(data) {
    return {type: dataConstants.DATA_SWIPE_SUCCESS, data}
}

function swipeFailure(token) {
    return {type: dataConstants.DATA_SWIPE_FAILURE, token}
}

/********* Batch Swipe GET Emplids Actions  *********************************/
function getbatchswipeemplidsRequest(token, deptId, eventId, occurId) {
    return {
        type: dataConstants.DATA_GETBATCHSWIPEEMPLIDS_REQUEST,
        token,
        deptId,
        eventId,
        occurId,
    }
}

function getbatchswipeemplidsSuccess(data) {
    return {type: dataConstants.DATA_GETBATCHSWIPEEMPLIDS_SUCCESS, data}
}

function getbatchswipeemplidsFailure(token) {
    return {type: dataConstants.DATA_GETBATCHSWIPEEMPLIDS_FAILURE, token}
}

/********* Batch Swipe Validation Actions  *********************************/
function batchswipevalidateRequest(
    token,
    deptId,
    eventId,
    occurId,
    swipeIdArray
) {
    return {
        type: dataConstants.DATA_BATCHSWIPEVALIDATE_REQUEST,
        token,
        deptId,
        eventId,
        occurId,
        swipeIdArray,
    }
}

function batchswipevalidateSuccess(data) {
    return {type: dataConstants.DATA_BATCHSWIPEVALIDATE_SUCCESS, data}
}

function batchswipevalidateFailure(token) {
    return {type: dataConstants.DATA_BATCHSWIPEVALIDATE_FAILURE, token}
}

function batchswipevalidateClear() {
    return {type: dataConstants.DATA_BATCHSWIPEVALIDATE_CLEAR}
}

/********* Batch Record Swipe Actions  *********************************/
function batchswiperecordRequest(
    token,
    deptId,
    eventId,
    occurId,
    selectedStartDate,
    swipeIdArray
) {
    return {
        type: dataConstants.DATA_BATCHSWIPERECORD_REQUEST,
        token,
        deptId,
        eventId,
        occurId,
        selectedStartDate,
        swipeIdArray,
    }
}

function batchswiperecordSuccess(data) {
    return {type: dataConstants.DATA_BATCHSWIPERECORD_SUCCESS, data}
}

function batchswiperecordFailure(token) {
    return {type: dataConstants.DATA_BATCHSWIPERECORD_FAILURE, token}
}

/********* Fetch Department Swipe Teams Actions  *********************************/
function swipeteamsFetchRequest(token, deptId) {
    return {type: dataConstants.DATA_GETSWIPETEAMS_REQUEST, token, deptId}
}

function swipeteamsFetchSuccess(swipeteamlist) {
    return {type: dataConstants.DATA_GETSWIPETEAMS_SUCCESS, swipeteamlist}
}

function swipeteamsFetchFailure(message) {
    return {type: dataConstants.DATA_GETSWIPETEAMS_FAILURE, message}
}

/********* GET a specific Swipe Team Actions  *********************************/
function getswipeteamFetchRequest(token, payload) {
    return {type: dataConstants.DATA_GETDEPTSWIPETEAM_REQUEST, token, payload}
}

function getswipeteamFetchSuccess(swipeteam) {
    return {type: dataConstants.DATA_GETDEPTSWIPETEAM_SUCCESS, swipeteam}
}

function getswipeteamFetchFailure(message) {
    return {type: dataConstants.DATA_GETDEPTSWIPETEAM_FAILURE, message}
}

function getswipeteamClearResults() {
    return {type: dataConstants.DATA_GETDEPTSWIPETEAM_CLEARRESULTS}
}

/********* Event Setup ADD Category Actions  *********************************/
function swipeteamAddRequest(token, payload) {
    return {
        type: dataConstants.DATA_ADDSWIPETEAM_REQUEST,
        token,
        payload,
    }
}

function swipeteamAddSuccess(data) {
    return {type: dataConstants.DATA_ADDSWIPETEAM_SUCCESS, data}
}

function swipeteamAddFailure(token) {
    return {type: dataConstants.DATA_ADDSWIPETEAM_FAILURE, token}
}

/********* Event Setup UPDATE Swipe Team Actions  *********************************/
function swipeteamUpdateRequest(token, payload) {
    return {
        type: dataConstants.DATA_UPDATESWIPETEAM_REQUEST,
        token,
        payload,
    }
}

function swipeteamUpdateSuccess(data) {
    return {type: dataConstants.DATA_UPDATESWIPETEAM_SUCCESS, data}
}

function swipeteamUpdateFailure(token) {
    return {type: dataConstants.DATA_UPDATESWIPETEAM_FAILURE, token}
}

/********* Event Setup Delete Swipe Team Actions  *********************************/
function swipeteamDeleteRequest(token, payload) {
    return {
        type: dataConstants.DATA_DELETESWIPETEAM_REQUEST,
        token,
        payload,
    }
}

function swipeteamDeleteSuccess() {
    return {type: dataConstants.DATA_DELETESWIPETEAM_SUCCESS}
}

function swipeteamDeleteFailure() {
    return {type: dataConstants.DATA_DELETESWIPETEAM_FAILURE}
}

/********* GET Engagement Type Actions  *********************************/
function engagementtypeRequest(token) {
    return {type: dataConstants.DATA_ENGAGEMENTTYPE_REQUEST, token}
}

function engagementtypeSuccess(engagementtypelist) {
    return {type: dataConstants.DATA_ENGAGEMENTTYPE_SUCCESS, engagementtypelist}
}

function engagementtypeFailure(message) {
    return {type: dataConstants.DATA_ENGAGEMENTTYPE_FAILURE, message}
}

/********* GET Departments Actions  *********************************/
function departmentsDataRequest(token) {
    return {type: dataConstants.DATA_DEPARTMENTS_REQUEST, token}
}

function departmentsDataSuccess(departmentslist) {
    return {type: dataConstants.DATA_DEPARTMENTS_SUCCESS, departmentslist}
}

function departmentsDataFailure(message) {
    return {type: dataConstants.DATA_DEAPRTMENTS_FAILURE, message}
}

/********* SET Active Departments Actions  *********************************/
function setdepartmentsDataRequest(token, activedepartment) {
    return {
        type: dataConstants.DATA_SETACTDEPARTMENT_REQUEST,
        token,
        activedepartment,
    }
}

function setdepartmentsDataSuccess(activedepartment) {
    return {type: dataConstants.DATA_SETACTDEPARTMENT_SUCCESS, activedepartment}
}

function setdepartmentsDataFailure(message) {
    return {type: dataConstants.DATA_SETACTDEPARTMENT_FAILURE, message}
}

/********* GET Super Admins Actions  *********************************/
function getsuperadminsRequest(token) {
    return {type: dataConstants.DATA_GETSUPERADMINS_REQUEST, token}
}

function getsuperadminsSuccess(superadminslist) {
    return {type: dataConstants.DATA_GETSUPERADMINS_SUCCESS, superadminslist}
}

function getsuperadminsFailure(message) {
    return {type: dataConstants.DATA_GETSUPERADMINS_FAILURE, message}
}

/********* PUT Super Admins Actions  *********************************/
function putsuperadminRequest(token, payload) {
    return {type: dataConstants.DATA_PUTSUPERADMIN_REQUEST, token, payload}
}

function putsuperadminSuccess(superadminslist) {
    return {type: dataConstants.DATA_PUTSUPERADMIN_SUCCESS, superadminslist}
}

function putsuperadminFailure(message) {
    return {type: dataConstants.DATA_PUTSUPERADMIN_FAILURE, message}
}

/********* SET Manage Roles Department Actions  *********************************/
function manageroledeptSetRequest(payload) {
    return {
        type: dataConstants.DATA_SETMANAGEROLEDEPT_REQUEST,
        payload,
    }
}

function manageroledeptSetSuccess(manageroledept) {
    return {
        type: dataConstants.DATA_SETMANAGEROLEDEPT_SUCCESS,
        manageroledept,
    }
}

function manageroledeptSetFailure(message) {
    return {type: dataConstants.DATA_SETMANAGEROLEDEPT_FAILURE, message}
}

function manageroledeptSetClear(manageroledept) {
    return {type: dataConstants.DATA_SETMANAGEROLEDEPT_CLEAR, manageroledept}
}

/********* Manage Department ADD Department Actions  *********************************/
function manageroledeptAddRequest(token, payload) {
    return {
        type: dataConstants.DATA_ADDMANAGEROLEDEPT_REQUEST,
        token,
        payload,
    }
}

function manageroledeptAddSuccess(data) {
    return {type: dataConstants.DATA_ADDMANAGEROLEDEPT_SUCCESS, data}
}

function manageroledeptAddFailure(token) {
    return {type: dataConstants.DATA_ADDMANAGEROLEDEPT_FAILURE, token}
}

/********* Manage Department UPDATE Department Actions  *********************************/
function manageroledeptUpdateRequest(token, payload) {
    return {
        type: dataConstants.DATA_UPDMANAGEROLEDEPT_REQUEST,
        token,
        payload,
    }
}

function manageroledeptUpdateSuccess(data) {
    return {type: dataConstants.DATA_UPDMANAGEROLEDEPT_SUCCESS, data}
}

function manageroledeptUpdateFailure(token) {
    return {type: dataConstants.DATA_UPDMANAGEROLEDEPT_FAILURE, token}
}

/********* Manage Department DELETE Department Actions  *********************************/
function manageroledeptDeleteRequest(token, payload) {
    return {
        type: dataConstants.DATA_DELMANAGEROLEDEPT_REQUEST,
        token,
        payload,
    }
}

function manageroledeptDeleteSuccess() {
    return {type: dataConstants.DATA_DELMANAGEROLEDEPT_SUCCESS}
}

function manageroledeptDeleteFailure() {
    return {type: dataConstants.DATA_DELMANAGEROLEDEPT_FAILURE}
}

/********* Department Users Actions  *********************************/
function departmentusersGetRequest(payload) {
    return {
        type: dataConstants.DATA_GETDEPARTMENTUSERS_REQUEST,
        payload,
    }
}

function departmentusersGetSuccess(departmentusers) {
    return {
        type: dataConstants.DATA_GETDEPARTMENTUSERS_SUCCESS,
        departmentusers,
    }
}

function departmentusersGetFailure(message) {
    return {type: dataConstants.DATA_GETDEPARTMENTUSERS_FAILURE, message}
}

function departmentusersGetClear(departmentusers) {
    return {type: dataConstants.DATA_GETDEPARTMENTUSERS_CLEAR, departmentusers}
}

function departmentusersAddRequest(token, payload) {
    return {
        type: dataConstants.DATA_ADDDEPARTMENTUSERS_REQUEST,
        token,
        payload,
    }
}

function departmentusersAddSuccess(data) {
    return {
        type: dataConstants.DATA_ADDDEPARTMENTUSERS_SUCCESS,
        data,
    }
}

function departmentusersAddFailure(message) {
    return {type: dataConstants.DATA_ADDDEPARTMENTUSERS_FAILURE, message}
}

function departmentusersUpdateRequest(token, payload) {
    return {
        type: dataConstants.DATA_UPDDEPARTMENTUSERS_REQUEST,
        token,
        payload,
    }
}

function departmentusersUpdateSuccess(data) {
    return {
        type: dataConstants.DATA_UPDDEPARTMENTUSERS_SUCCESS,
        data,
    }
}

function departmentusersUpdateFailure(message) {
    return {type: dataConstants.DATA_UPDDEPARTMENTUSERS_FAILURE, message}
}

/********* Department Users Delete Department Actions  *********************************/
function departmentusersDeleteRequest(token, payload) {
    return {
        type: dataConstants.DATA_DELDEPARTMENTUSERS_REQUEST,
        token,
        payload,
    }
}

function departmentusersDeleteSuccess() {
    return {type: dataConstants.DATA_DELDEPARTMENTUSERS_SUCCESS}
}

function departmentusersDeleteFailure() {
    return {type: dataConstants.DATA_DELDEPARTMENTUSERS_FAILURE}
}

/********* SuperAdmin Audit Users Actions  *********************************/
function allusersGetRequest(token) {
    return {
        type: dataConstants.DATA_GETALLUSERS_REQUEST,
        token,
    }
}

function allusersGetSuccess(allusers) {
    return {
        type: dataConstants.DATA_GETALLUSERS_SUCCESS,
        allusers,
    }
}

function allusersGetFailure(message) {
    return {type: dataConstants.DATA_GETALLUSERS_FAILURE, message}
}

function allusersGetClear(allusers) {
    return {type: dataConstants.DATA_GETALLUSERS_CLEAR, allusers}
}
